var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"image-note-wrap"}},[_c('span',{staticClass:"title-and-exit"},[_c('input',{staticClass:"title-input",attrs:{"type":"text"},domProps:{"value":_vm.title},on:{"input":_vm.updateTitle}}),_c('button',{staticClass:"delete-note",on:{"click":_vm.deleteNote}},[_vm._v("X")])]),_c('img',{attrs:{"src":"","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }